import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

export interface IBuildingUserType {
  value: number;
  label: string; // translation key
}

/**
 * User types available in the building activity filter. Each `value` matches a
 * `userType` Int understood by the `FilterCriteria` backend input (1..5). The
 * backend only accepts a single value, so the filter is single-select.
 */
export const BUILDING_USER_TYPES: IBuildingUserType[] = [
  { value: 1, label: 'PROPERTY_MANAGER_ADMIN' },
  { value: 2, label: 'PROPERTY_MANAGER_USER' },
  { value: 3, label: 'INSTALLER_ADMIN' },
  { value: 4, label: 'INSTALLER_USER' },
  { value: 5, label: 'RESIDENT' },
];

@Component({
  selector: 'app-user-type',
  templateUrl: './user-type.component.html',
  styleUrls: ['./user-type.component.scss'],
})
export class UserTypeComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();

  formGroup!: FormGroup;
  readonly CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;
  readonly userTypes = BUILDING_USER_TYPES;

  selectedUserType: number | null = null;
  holdPreviousState: number | null = null;

  constructor(public rootFormGroup: FormGroupDirective) {}

  ngOnInit(): void {
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.holdPreviousState = this.formGroup?.controls?.userType?.value ?? null;
    this.selectedUserType = this.holdPreviousState;
  }

  /**
   * @description whether the given user type is currently selected
   * @returns boolean
   */
  isSelected(value: number): boolean {
    return this.selectedUserType === value;
  }

  /**
   * @description whether anything is selected (drives the Reset button state)
   * @returns boolean
   */
  get hasSelection(): boolean {
    return this.selectedUserType !== null;
  }

  /**
   * @description select/deselect a user type (single-select)
   * @returns void
   */
  toggleUserType(value: number): void {
    this.selectedUserType = this.isSelected(value) ? null : value;
  }

  /**
   * @description clear the current selection
   * @returns void
   */
  resetFilter(): void {
    this.selectedUserType = null;
  }

  /**
   * @description persist selection into the parent form and go back to the list
   * @returns void
   */
  submit(): void {
    this.formGroup.patchValue({ userType: this.selectedUserType });
    this.stepperChange.emit((this.stepper = 1));
  }

  /**
   * @description discard changes and navigate back to the list
   * @returns void
   */
  navigateBack(): void {
    this.selectedUserType = this.holdPreviousState;
    this.stepperChange.emit((this.stepper = 1));
  }
}
